import { useState, useEffect } from "react";
import { getAuthUser } from "../../../services/auth";

const initialForm = {
  id: null,
  name: "",
  phone_number: "",
  email: "",
  organization: "",
  product_needs: "",
  product_category: "",
  product_subcategory: "",
  product_type: "",
  organization_type: "",
  lead_source: "",
  company: "",
  mo_id: [],
  tls_id: [],
  sales_id: [],
  lead_status: "",
  spk_status: "",
  click_plan: "",
  budget: "",
  estimated_budget: "",
  contract_value: "",
  notes: "",
  response_status: "",
};

export default function useDBLeadForm() {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [validated, setValidated] = useState(false);
  const auth = getAuthUser();

  const validate = () => {
    const newErrors = {};

    if (!form.name.trim()) newErrors.name = "Nama wajib diisi.";
    if (!form.phone_number) {
      newErrors.phone_number = "Nomor Telepon wajib diisi.";
    } else if (!/^[0-9]+$/.test(form.phone_number)) {
      newErrors.phone_number = "Nomor telepon hanya boleh angka.";
    } else if (form.phone_number.startsWith("0")) {
      newErrors.phone_number = "Nomor telepon tidak boleh diawali dengan 0.";
    } else if (form.phone_number.startsWith("8")) {
      // Validasi nomor HP
      if (form.phone_number.length < 9) {
        newErrors.phone_number = "Nomor HP minimal 9 digit.";
      } else if (form.phone_number.length > 13) {
        newErrors.phone_number = "Nomor HP maksimal 13 digit.";
      }
    } else {
      // Validasi nomor rumah
      if (form.phone_number.length < 5) {
        newErrors.phone_number = "Nomor telepon rumah minimal 5 digit.";
      } else if (form.phone_number.length > 13) {
        newErrors.phone_number = "Nomor telepon rumah maksimal 13 digit.";
      }
    }

    if (form.email && !/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = "Format email tidak valid.";
    }
    if (!form.organization.trim())
      newErrors.organization = "Instansi/Business wajib diisi.";
    if (!form.product_needs.trim())
      newErrors.product_needs = "Kebutuhan Product wajib diisi.";
    if (!form.product_category)
      newErrors.product_category = "Kategory Product wajib diisi.";
    if (!form.organization_type.trim())
      newErrors.organization_type = "Pemerintah/Swasta wajib diisi.";
    if (!form.lead_source.trim())
      newErrors.lead_source = "Sumber Leads wajib diisi.";
    if (!form.company.trim()) newErrors.company = "Perusahaan wajib diisi.";
    if (!form.lead_status.trim())
      newErrors.lead_status = "Status Leads wajib diisi.";
    if (!form.spk_status) newErrors.spk_status = "Progres wajib diisi.";
    if (!form.click_plan) newErrors.click_plan = "Rencana Klik wajib diisi.";
    if (!form.notes.trim()) newErrors.notes = "Keterangan wajib diisi.";
    if (!form.response_status.trim())
      newErrors.response_status = "Tidak Respon/Respon wajib diisi.";

    if (!form.mo_id || form.mo_id.length === 0)
      newErrors.mo_id = "Pilih MO minimal 1.";
    if (!form.tls_id || form.tls_id.length === 0)
      newErrors.tls_id = "Pilih TLS minimal 1.";
    if (!form.sales_id || form.sales_id.length === 0)
      newErrors.sales_id = "Pilih Sales minimal 1.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const numericFields = [
      "phone_number",
      "budget",
      "estimated_budget",
      "contract_value",
    ];

    const parsedValue = numericFields.includes(name)
      ? value.replace(/\D/g, "")
      : value;

    const updatedForm = {
      ...form,
      [name]: parsedValue,
    };

    const rab = parseFloat(updatedForm.estimated_budget) || 0;
    const nominalSPK = parseFloat(updatedForm.contract_value) || 0;

    if (rab > 0 && nominalSPK > 0) {
      updatedForm.profit = Math.round(((nominalSPK - rab) / rab) * 100);
    } else {
      updatedForm.profit = 0;
    }

    setForm(updatedForm);
  };

  const handleSelectChange = (field) => (selected) => {
    const values = selected ? selected.map((s) => s.value) : [];
    setForm((prev) => ({ ...prev, [field]: values }));
  };

  const resetForm = () => {
    setForm({
      ...initialForm,
      product_category: initialForm.product_category?.id || "",
    });
    setErrors({});
    setValidated(false);
  };

  return {
    form,
    setForm,
    errors,
    validated,
    setValidated,
    validate,
    handleChange,
    handleSelectChange,
    resetForm,
  };
}
